<template>
    <section class="py-5 bg-light">
        <div class="container">
            <h2 class="text-center mb-4">国内分布</h2>
            <div id="china-map" style="width: 100%; height: 500px;"></div>
        </div>
    </section>
</template>

<script>
import * as echarts from 'echarts/core';
import {
    TooltipComponent,
} from 'echarts/components';
import {
    MapChart
} from 'echarts/charts';
import {
    CanvasRenderer
} from 'echarts/renderers';

echarts.use([
    TooltipComponent,
    MapChart,
    CanvasRenderer
]);

export default {
    name: 'ChinaMap2',
  
    data() {
        return {
            chinaChart: null,
            data: []
        };
    },

    mounted() {
        this.initChart();
        this.getCatalogTreeData();
    },

    beforeDestroy() {
        if (this.chinaChart) {
            window.removeEventListener('resize', this.handleResize);
            this.chinaChart.dispose();
        }
    },

    methods: {
        initChart() {
            this.chinaChart = echarts.init(document.getElementById('china-map'));
          
            const option = {
                tooltip: {
                    trigger: 'item',
                    confine: true,
                    className: 'echarts-tooltip-custom',
                    formatter: function (params) {
                        if (!params.data) return;
                        const isMobile = window.innerWidth <= 768;
                        let html = `<div class="${isMobile ? 'mobile-tooltip' : ''}">`;
                        html += `<div class="tooltip-title">${params.name}</div>`;
                        // 只有当不是广东省时才显示合伙人数量
                        if (params.name !== '广东' && params.name !== '广东省') {
                            html += `<div class="tooltip-count">合伙人数量：${params.data.dealers.length}</div>`;
                        }
                        html += `<div class="tooltip-list">`;
                        params.data.dealers.forEach(dealer => {
                            html += `<div class="dealer-item">`;
                            html += `<div class="dealer-name">${dealer.name}</div>`;
                            html += `<div class="dealer-contact">电话：${dealer.tel}</div>`;
                            html += `<div class="dealer-address">${dealer.address}</div>`;
                            html += `</div>`;
                        });
                        html += `</div></div>`;
                        return html;
                    }
                },
                series: [{
                    name: '经销商分布',
                    type: 'map',
                    map: 'china',
                    roam: false,
                    emphasis: {
                        label: {
                            show: true
                        }
                    },
                   
                    data: this.data
                }]
            };

            window.addEventListener('resize', this.handleResize);
          
            this.loadMapData(option);
        },

        async loadMapData(option, retryCount = 0) {
            try {
                const response = await fetch('https://cdn.jsdelivr.net/npm/echarts@4.9.0/map/json/china.json');
                const chinaJson = await response.json();
                echarts.registerMap('china', chinaJson);
                this.chinaChart.setOption(option);
                console.log('地图数据加载成功');
            } catch (error) {
                console.error(`第 ${retryCount + 1} 次加载地图数据失败:`, error);
                const retryDelay = (retryCount + 1) * 1000; // 每次失败延迟递增（1秒、2秒...）
                console.log(`${retryDelay / 1000}秒后重试...`);
                setTimeout(() => {
                    this.loadMapData(option, retryCount + 1); // 无限重试
                }, retryDelay);
            }
        },

        handleResize() {
            if (this.chinaChart) {
                this.chinaChart.resize();
            }
        },

        async getCatalogTreeData() {
            try {
                const response = await this.$http.get('/cms/catalog/treeData');
                if (response.code === 200) {
                    const targetData = response.data.rows[0].children.find(item => item.id === '646436734607429');
                    if (targetData && targetData.children) {
                        const branchData = await Promise.all(
                            targetData.children.map(async branch => {
                                const branchResponse = await this.$http.get('/cms/content/front-list', {
                                    params: {
                                        pageNum: 1,
                                        pageSize: 10,
                                        catalogId: branch.id
                                    }
                                });
                                if (branchResponse.code === 200 && branchResponse.data.rows.length > 0) {
                                    const dealers = branchResponse.data.rows.map(content => ({
                                        name: content.title,
                                        tel: content.shortTitle.replace('座机：', '').replace('电话：', ''),
                                        address: content.subTitle
                                    }));

                                    const value = Math.min(branchResponse.data.total, 10) * 1;

                                    const areaColor = value > 5 ? '#5F27CD' : '#C8E6FF';

                                    return {
                                        name: branch.label,
                                        value: value,
                                        dealers: dealers,
                                        itemStyle: {
                                            areaColor: areaColor
                                        }
                                    };
                                }
                                return null;
                            })
                        );

                        this.data = branchData.filter(item => item !== null);

                        if (this.chinaChart) {
                            this.chinaChart.setOption({
                                series: [{
                                    data: this.data
                                }]
                            });
                        }
                    }
                }
            } catch (error) {
                console.error('获取目录树数据失败:', error);
            }
        },
    }
};
</script>

<style>
/* Tooltip 样式 */
.echarts-tooltip-custom {
    width: auto !important;
    max-width: 90vw !important;
    min-width: 200px !important;
    overflow-wrap: break-word !important;
    white-space: normal !important;
}

.echarts-tooltip-custom .tooltip-title {
    font-weight: bold;
    margin-bottom: 5px;
    font-size: 16px;
}

.echarts-tooltip-custom .tooltip-count {
    margin-bottom: 10px;
    color: #666;
}

.echarts-tooltip-custom .tooltip-list {
    max-height: 60vh;
    overflow-y: auto;
}

.echarts-tooltip-custom .dealer-item {
    padding: 8px 0;
    border-bottom: 1px solid #eee;
}

.echarts-tooltip-custom .dealer-item:last-child {
    border-bottom: none;
}

.echarts-tooltip-custom .dealer-name {
    font-weight: bold;
    margin-bottom: 3px;
}

.echarts-tooltip-custom .dealer-contact,
.echarts-tooltip-custom .dealer-address {
    font-size: 13px;
    color: #666;
    line-height: 1.4;
}
.text-center{
    text-align: center;
}

/* 移动端特殊样式 */
@media screen and (max-width: 768px) {
    .echarts-tooltip-custom.mobile-tooltip {
        padding: 8px !important;
        font-size: 12px !important;
    }

    .echarts-tooltip-custom .tooltip-title {
        font-size: 14px;
    }

    .echarts-tooltip-custom .dealer-item {
        padding: 5px 0;
    }

    .echarts-tooltip-custom .dealer-contact,
    .echarts-tooltip-custom .dealer-address {
        font-size: 12px;
    }
}
</style>